import axios from 'axios'

const http = axios.create({
  baseURL: '/api/'
})

const api = {
  // global
  currentUser() {
    return http.get('currentUser')
  },
  getMenu() {
    return http.get('menu')
  },

  // tasks
  fetchMyTasks(page, params, size = 15) {
    return http.get('task/listing', {
      params: {
        ...params,
        page: page,
        size: size
      }
    })
  },
  fetchBorrowerInfo(loanId) {
    return http.get('task/userInfo/' + loanId, {})
  },
  fetchTaskInfo(taskId) {
    return http.get('task/info/' + taskId, {})
  },
  fetchLoanItemInfo(taskId) {
    return http.get('task/loanItemInfo/' + taskId, {})
  },
  fetchContactsInfo(loanId) {
    return http.get('task/contacts/' + loanId, {})
  },
  fetchUserContactsInfo(loanId) {
    return http.get('task/userContacts/' + loanId, {})
  },
  fetchUserCallsInfo(loanId) {
    return http.get('task/userCalls/' + loanId, {})
  },
  recordCollectionLog(loanId, params) {
    return http.post('task/record/' + loanId, params)
  },
  fetchCollectionLogs(taskId) {
    return http.get('task/collectionLogs/' + taskId, {})
  },
  fetchSmsTemplates(loanId) {
    return http.get('sms/templates/', {})
  },
  sendSms(params) {
    return http.post('sms/send', params)
  },
  deduct(planId, params) {
    return http.post('repay/deduct/' + planId, params)
  },
  fetchRepayDetails(params) {
    return http.get('repay/details', {
      params: params
    })
  },
  fetchPayLogs(params) {
    return http.get('repay/payLogs', {
      params: params
    })
  },
  fetchRepayStatistics(page, size = 50, date = 'today') {
    return http.get('repay/statistics/', {
      params: {
        page: page,
        size: size,
        date: date
      }
    })
  },
  downloadRepayStatistics({
    page,
    size = 50,
    date = 'today'
  }) {
    return http.get('repay/statistics/', {
      responseType: 'blob',
      params: {
        page: page,
        size: size,
        date: date,
        output: 1
      }
    }).then((res) => {
      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = res.headers.filename // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    })
  },
  downloadAchievements(params) {
    return http.get('taskReport/download', {
      responseType: 'blob',
      params
    }).then((res) => {
      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = `achievements.xls` // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    })
  },
  // 人工分案导入模板下载
  downManualDivisionTasksTemplate() {
    return http.get('task/downManualDivisionTasksTemplate', {
      responseType: 'blob',
    }).then((res) => {
      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = `人工分案导入模板.xls` // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    })
  },
  // 可分配名单Excel模板
  downOutsourcedDivisionTasksTemplate() {
    return http.get('task/downOutsourcedDivisionTasksTemplate', {
      responseType: 'blob',
    }).then((res) => {
      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = `委外名单导入模板.xls` // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    })
  },
  // 上传留案名单/取消留案名单模板
  downStayOnFileTemplate() {
    return http.get('task/downStayOnFileTemplate', {
      responseType: 'blob',
    }).then((res) => {
      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = `留案名单导入模板.xls` // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    })
  },
  // management queue
  fetchManagementQueue(page, size, type, searchParams) {
    return http.get('management/queue/list/', {
      params: {
        ...searchParams,
        type: type,
        page: page,
        size: size
      }
    })
  },
  fetchQueueInfo(queueId) {
    return http.get('management/queue/info/' + queueId, {})
  },
  fetchQueueTasks(queueId, page, size, searchParams) {
    return http.get('management/queue/tasks/' + queueId, {
      params: {
        ...searchParams,
        page: page,
        size: size
      }
    })
  },
  fetchQueueAgents(queueId) {
    return http.get('management/queue/agents/' + queueId, {})
  },
  bindQueueAgent(taskIds, agentId, name, id, workQueueId) {
    return http.post('management/task/bindAgent', {
      taskIds: taskIds,
      agentId: agentId,
      creator: name,
      creatorId: id,
      workQueueId
    })
  },
  unbindQueueAgent(taskIds) {
    return http.post('management/task/unbindAgent', {
      taskIds: taskIds
    })
  },

  // management user
  fetchManagementUserList(page, size, searchParams) {
    return http.get('management/user/list/', {
      params: {
        ...searchParams,
        page: page,
        size: size
      }
    })
  },
  fetchAgentInfo(id) {
    return http.get('management/user/info/' + id)
  },
  postAgentInfo(params) {
    return http.post('management/user/info/' + (params.id || ''), {
      ...params
    })
  },
  fetchInstitutionTree() {
    return http.get('management/institution/tree')
  }
}

export default api
